<template>
  <v-row no-gutters class="legal-notice-header">
    <v-col cols="12">
      <v-row no-gutters justify="center">
        <v-col cols="12">
          <center>
            <span class="font-weight-bold display-1">{{ title }}</span>
          </center>
        </v-col>
      </v-row>
      <v-row class="mt-5 body-content" v-for="row in rows" :key="row.title" no-gutters>
        <v-col cols="12">
          <span class="font-weight-bold headline">{{ row.title }}</span><br/><br/>
          <span v-html="row.text" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    title: 'Mandatory Legal Notice',
    rows: [
      {
        title: '1.  Editor',
        text: 'In accordance with the provisions of article 6-I 1° of Act n°2004-575 of June 21st, 2004 on confidence in the digital economy, the website editor of <a href="https://www.musicworldmedia.com">www.musicworldmedia.com</a> is :<br /><br /><b>MWM</b>, a French simplified joint stock company (<i>"société par actions simplifiée"</i>), with a share capital of  2 098,79 Euros, whose head office is located 54/56, avenue du Général Leclerc, 92100 Boulogne-Billancourt, France, registered in the Nanterre Trades and Companies Register under number 513 627 299, <br /><br />Phone number: +33 (0)9 82 29 20 98<br />Email address: ariane@musicworldmedia.com'
      },
      {
        title: '2.  Publication Director',
        text: 'The Publication Director of this website : <a href="https://www.musicworldmedia.com">www.musicworldmedia.com</a> is Mr. Jean-Baptiste Hironde as Chief Executive Officer of the Company MWM.'
      },
      {
        title: '3.  Hosting',
        text: 'The service provider ensuring the direct and permanent hosting of the website <a href="https://www.musicworldmedia.com">www.musicworldmedia.com</a> is Google Ireland Limited, a company incorporated under Irish law registered in Ireland (under number : 368047) whose head office is at Gordon House, Barrow Street, Dublin 4, Irlande.'
      }
    ]
  }),
  components: {

  },
  methods: {

  },
  computed: {

  },
  mounted () {

  }
};
</script>

<style scoped lang="css">
.legal-notice-header {
  margin-top: 10rem;
}

.body-content {
  margin-left: 15rem;
  margin-right: 15rem;
}
</style>
